import { b as V, g as w, d as W, a as $, c as Q, s as U } from "./index-E8vB_04G.js";
import { l as S } from "./index-b-LDu0Rp.js";
import { n as C } from "./nacl-fast-DmSj04OB.js";
import { l as we } from "./lodash-CQY7Uy6L.js";
import { d as Se } from "./index-Buti0PLx.js";
import { secret_store as K } from "ddc";
import { c as q, g as ge } from "./_commonjsHelpers-CT_km90n.js";
import { Verification as Re } from "sgx-ias-verifier";
import ee from "./config.js";
import { Sigma as De } from "./authentication.js";
class z {
  buffer;
  currentOffset;
  constructor(e) {
    this.buffer = e, this.currentOffset = 0;
  }
  static withSize(e) {
    const t = new Uint8Array(e);
    return new z(t);
  }
  extend(e) {
    const t = this.currentOffset + e.length;
    if (t > this.buffer.byteLength) {
      const o = this.buffer;
      this.buffer = new Uint8Array(t * 2), this.buffer.set(o);
    }
    this.buffer.set(e, this.currentOffset), this.currentOffset += e.length;
  }
  reset() {
    this.currentOffset = 0;
  }
  view(e = !1) {
    const t = this.buffer.subarray(0, this.currentOffset);
    return e ? t.slice() : t;
  }
  size() {
    return this.currentOffset;
  }
}
var ve = /* @__PURE__ */ ((n) => (n.ExportDataset = "EXPORT_DATASET", n.ExportDcrJobResult = "EXPORT_DCR_JOB_RESULT", n.ImportDataset = "IMPORT_DATASET", n))(ve || {}), Ee = /* @__PURE__ */ ((n) => (n.Azure = "AZURE", n.Compute = "COMPUTE", n.ComputeV2 = "COMPUTE_V2", n.Databricks = "DATABRICKS", n.GoogleCloudStorage = "GOOGLE_CLOUD_STORAGE", n.Local = "LOCAL", n.Permutive = "PERMUTIVE", n.S3 = "S3", n.Salesforce = "SALESFORCE", n.Snowflake = "SNOWFLAKE", n))(Ee || {}), _e = /* @__PURE__ */ ((n) => (n.Adform = "ADFORM", n.Azure = "AZURE", n.GoogleAds = "GOOGLE_ADS", n.GoogleAdManager = "GOOGLE_AD_MANAGER", n.GoogleCloudStorage = "GOOGLE_CLOUD_STORAGE", n.GoogleDv_360 = "GOOGLE_DV_360", n.Meta = "META", n.MicrosoftDsp = "MICROSOFT_DSP", n.Permutive = "PERMUTIVE", n.S3 = "S3", n.Snapchat = "SNAPCHAT", n.Splicky = "SPLICKY", n.Sportradar = "SPORTRADAR", n.Tiktok = "TIKTOK", n.TradeDesk = "TRADE_DESK", n))(_e || {});
class p extends String {
  constructor(e, t) {
    super(e), this.value = e, this.__meta__ = t;
  }
  __apiType;
  toString() {
    return this.value;
  }
}
const Te = new p(`
    query GetAttestationSpecsV2 {
  attestationSpecsV2 {
    name
    version
    spec
  }
}
    `), Oe = new p(`
    mutation GetOrCreateDatasetScope($input: CreateDatasetScopeInput!) {
  scope {
    getOrCreateDatasetScope(input: $input) {
      record {
        id
      }
    }
  }
}
    `), Ce = new p(`
    mutation GetOrCreateDcrDataScope($input: CreateDcrDataScopeInput!) {
  scope {
    getOrCreateDcrDataScope(input: $input) {
      record {
        id
      }
    }
  }
}
    `), $e = new p(`
    mutation CreateUpload {
  upload {
    create {
      record {
        id
      }
    }
  }
}
    `), qe = new p(`
    mutation FinalizeUpload($input: CreateDatasetForUploadInput!) {
  upload {
    finalizeUploadAndCreateDataset(input: $input) {
      record {
        id
        manifestHash
      }
    }
  }
}
    `), Ie = new p(`
    query GetDataset($manifestHash: HexString!) {
  datasetByManifestHash(manifestHash: $manifestHash) {
    id
    name
    manifestHash
    statistics
    size
    description
    createdAt
    usage
    datasetImport {
      dataRoomId
    }
    encryptionKeySecretId
    metadataSecretId
  }
}
    `), ke = new p(`
    query GetAvailableDatasets {
  myself {
    datasets {
      nodes {
        id
        name
        manifestHash
        statistics
        size
        description
        createdAt
        usage
        encryptionKeySecretId
        metadataSecretId
      }
    }
  }
}
    `), xe = new p(`
    mutation DeleteDataset($manifestHash: HexString!) {
  dataset {
    deleteByManifestHash(manifestHash: $manifestHash)
  }
}
    `), Pe = new p(`
    mutation CreateApiToken($input: CreateApiTokenInput!) {
  apiToken {
    create(input: $input) {
      id
      token
      name
      description
      revoked
      createdAt
    }
  }
}
    `), Ue = new p(`
    query getAllApiTokens {
  myself {
    apiTokens {
      nodes {
        id
        token
        name
        description
        revoked
        createdAt
      }
    }
  }
}
    `), He = new p(`
    mutation RevokeApiToken($id: String!) {
  apiToken {
    revoke(id: $id) {
      id
    }
  }
}
    `), Le = new p(`
    query GetUserId {
  myself {
    id
  }
}
    `), Be = new p(`
    query getCertificateAuthority {
  certificateAuthority {
    rootCertificate
  }
}
    `), Me = new p(`
    query GetPublishedDataRoom($dataRoomHash: String!) {
  publishedDataRoom(id: $dataRoomHash) {
    id
    title
    driverAttestationHash
    isStopped
    createdAt
    updatedAt
  }
}
    `), Ge = new p(`
    query getUserCertificate($input: UserCsrInput!) {
  certificateAuthority {
    userCertificate(input: $input)
  }
}
    `), Je = new p(`
    query GetScope($scopeId: String!) {
  scope(id: $scopeId) {
    id
    organization {
      id
      name
    }
    owner {
      id
      email
    }
    scopeType
    manifestHash
    dataRoomHash
    createdAt
  }
}
    `), Ke = new p(`
    mutation SetJobIdForDataConnectorJob($input: SetJobIdForDataConnectorJobInput!) {
  dataConnectorJob {
    setJobId(input: $input) {
      record {
        id
      }
    }
  }
}
    `), Ne = new p(`
    mutation SetDataConnectorJobToFailed($id: String!) {
  dataConnectorJob {
    setJobToFailed(id: $id) {
      record {
        id
      }
    }
  }
}
    `), Fe = new p(`
    mutation SetDataConnectorJobToSuccess($id: String!) {
  dataConnectorJob {
    setJobToSuccess(id: $id) {
      record {
        id
      }
    }
  }
}
    `), je = new p(`
    query GetDataConnectorJob($id: String!) {
  dataConnectorJob(id: $id) {
    name
    type
    computeJobId
    computeJobNode
    dataRoomId
    driverAttestationHash
  }
}
    `), Ve = new p(`
    mutation CreateDataConnectorJob($input: CreateDataConnectorJobInput!) {
  dataConnectorJob {
    create(input: $input) {
      record {
        id
      }
    }
  }
}
    `), ze = new p(`
    mutation SetDataLabJobIds($input: SetDataLabJobIdsInput!) {
  dataLab {
    setJobIds(input: $input) {
      record {
        id
      }
    }
  }
}
    `), Xe = new p(`
    mutation CreateDataLab($input: CreateDataLabInput!) {
  dataLab {
    create(input: $input) {
      record {
        id
        highLevelRepresentationAsString
      }
    }
  }
}
    `), Ye = new p(`
    query GetDataLab($id: String!) {
  dataLab(id: $id) {
    highLevelRepresentationAsString
  }
}
    `), Ze = new p(`
    query MicrosoftDspMemberFromOrganisation {
  myself {
    organization {
      microsoftDspMember
    }
  }
}
    `), We = new p(`
    mutation CreateSession($input: CreateSessionInput!) {
  session {
    create(input: $input) {
      record {
        id
        fatquoteNewTcbLevel
      }
    }
  }
}
    `), Qe = {
  "\n      query GetAttestationSpecsV2 {\n        attestationSpecsV2 {\n          name\n          version\n          spec\n        }\n      }\n    ": Te,
  "\n      mutation GetOrCreateDatasetScope($input: CreateDatasetScopeInput!) {\n        scope {\n          getOrCreateDatasetScope(input: $input) {\n            record {\n              id\n            }\n          }\n        }\n      }\n    ": Oe,
  "\n      mutation GetOrCreateDcrDataScope($input: CreateDcrDataScopeInput!) {\n        scope {\n          getOrCreateDcrDataScope(input: $input) {\n            record {\n              id\n            }\n          }\n        }\n      }\n    ": Ce,
  "\n      mutation CreateUpload {\n        upload {\n          create {\n            record {\n              id\n            }\n          }\n        }\n      }\n    ": $e,
  "\n      mutation FinalizeUpload($input: CreateDatasetForUploadInput!) {\n        upload {\n          finalizeUploadAndCreateDataset(input: $input) {\n            record {\n              id\n              manifestHash\n            }\n          }\n        }\n      }\n    ": qe,
  "\n      query GetDataset($manifestHash: HexString!) {\n        datasetByManifestHash(manifestHash: $manifestHash) {\n          id\n          name\n          manifestHash\n          statistics\n          size\n          description\n          createdAt\n          usage\n          datasetImport {\n            dataRoomId\n          }\n          encryptionKeySecretId\n          metadataSecretId\n        }\n      }\n    ": Ie,
  "\n      query GetAvailableDatasets {\n        myself {\n          datasets {\n            nodes {\n              id\n              name\n              manifestHash\n              statistics\n              size\n              description\n              createdAt\n              usage\n              encryptionKeySecretId\n              metadataSecretId\n            }\n          }\n        }\n      }\n    ": ke,
  "\n      mutation DeleteDataset($manifestHash: HexString!) {\n        dataset {\n          deleteByManifestHash(manifestHash: $manifestHash)\n        }\n      }\n    ": xe,
  "\n      mutation CreateApiToken($input: CreateApiTokenInput!) {\n        apiToken {\n          create(input: $input) {\n            id\n            token\n            name\n            description\n            revoked\n            createdAt\n          }\n        }\n      }\n    ": Pe,
  "\n        query getAllApiTokens {\n          myself {\n            apiTokens {\n              nodes {\n                id\n                token\n                name\n                description\n                revoked\n                createdAt\n              }\n            }\n          }\n        }\n      ": Ue,
  "\n        mutation RevokeApiToken($id: String!) {\n          apiToken {\n            revoke(id: $id) {\n              id\n            }\n          }\n        }\n      ": He,
  "\n        query GetUserId {\n          myself {\n            id\n          }\n        }\n      ": Le,
  "\n        query getCertificateAuthority {\n          certificateAuthority {\n            rootCertificate\n          }\n        }\n      ": Be,
  "\n        query GetPublishedDataRoom($dataRoomHash: String!) {\n          publishedDataRoom(id: $dataRoomHash) {\n            id\n            title\n            driverAttestationHash\n            isStopped\n            createdAt\n            updatedAt\n          }\n        }\n      ": Me,
  "\n        query getUserCertificate($input: UserCsrInput!) {\n          certificateAuthority {\n            userCertificate(input: $input)\n          }\n        }\n      ": Ge,
  "\n        query GetScope($scopeId: String!) {\n          scope(id: $scopeId) {\n            id\n            organization {\n              id\n              name\n            }\n            owner {\n              id\n              email\n            }\n            scopeType\n            manifestHash\n            dataRoomHash\n            # driverAttestationHash\n            createdAt\n          }\n        }\n      ": Je,
  "\n      mutation SetJobIdForDataConnectorJob(\n        $input: SetJobIdForDataConnectorJobInput!\n      ) {\n        dataConnectorJob {\n          setJobId(input: $input) {\n            record {\n              id\n            }\n          }\n        }\n      }\n    ": Ke,
  "\n      mutation SetDataConnectorJobToFailed($id: String!) {\n        dataConnectorJob {\n          setJobToFailed(id: $id) {\n            record {\n              id\n            }\n          }\n        }\n      }\n    ": Ne,
  "\n      mutation SetDataConnectorJobToSuccess($id: String!) {\n        dataConnectorJob {\n          setJobToSuccess(id: $id) {\n            record {\n              id\n            }\n          }\n        }\n      }\n    ": Fe,
  "\n      query GetDataConnectorJob($id: String!) {\n        dataConnectorJob(id: $id) {\n          name\n          type\n          computeJobId\n          computeJobNode\n          dataRoomId\n          driverAttestationHash\n        }\n      }\n    ": je,
  "\n      mutation CreateDataConnectorJob($input: CreateDataConnectorJobInput!) {\n        dataConnectorJob {\n          create(input: $input) {\n            record {\n              id\n            }\n          }\n        }\n      }\n    ": Ve,
  "\n      mutation SetDataLabJobIds($input: SetDataLabJobIdsInput!) {\n        dataLab {\n          setJobIds(input: $input) {\n            record {\n              id\n            }\n          }\n        }\n      }\n    ": ze,
  "\n      mutation CreateDataLab($input: CreateDataLabInput!) {\n        dataLab {\n          create(input: $input) {\n            record {\n              id\n              highLevelRepresentationAsString\n            }\n          }\n        }\n      }\n    ": Xe,
  "\n      query GetDataLab($id: String!) {\n        dataLab(id: $id) {\n          highLevelRepresentationAsString\n        }\n      }\n    ": Ye,
  "\n    query MicrosoftDspMemberFromOrganisation {\n      myself {\n        organization {\n          microsoftDspMember\n        }\n      }\n    }\n  ": Ze,
  "\n        mutation CreateSession($input: CreateSessionInput!) {\n          session {\n            create(input: $input) {\n              record {\n                id\n                fatquoteNewTcbLevel\n              }\n            }\n          }\n        }\n      ": We
};
function et(n) {
  return Qe[n] ?? {};
}
var N = {}, M = {};
Object.defineProperty(M, "__esModule", { value: !0 });
M.coalesceAsync = void 0;
const k = /* @__PURE__ */ new Map();
async function tt(n, e) {
  if (!nt(n)) {
    rt(n);
    try {
      const t = await Promise.resolve(e());
      return te({ key: n, result: t }), t;
    } catch (t) {
      throw te({ key: n, error: t }), t;
    }
  }
  return at(n);
}
M.coalesceAsync = tt;
function nt(n) {
  return k.has(n);
}
function rt(n) {
  k.set(n, []);
}
function st(n) {
  k.delete(n);
}
function ot(n, e) {
  const t = ne(n);
  t.push(e), k.set(n, t);
}
function ne(n) {
  return k.get(n) ?? [];
}
function at(n) {
  return new Promise((e, t) => {
    ot(n, { resolve: e, reject: t });
  });
}
function it(n) {
  const e = ne(n);
  return st(n), e;
}
function te(n) {
  const { key: e, error: t, result: o } = n;
  it(e).forEach((s) => {
    t ? s.reject(t) : s.resolve(o);
  });
}
(function(n) {
  var e = q && q.__createBinding || (Object.create ? function(o, s, i, u) {
    u === void 0 && (u = i);
    var c = Object.getOwnPropertyDescriptor(s, i);
    (!c || ("get" in c ? !s.__esModule : c.writable || c.configurable)) && (c = { enumerable: !0, get: function() {
      return s[i];
    } }), Object.defineProperty(o, u, c);
  } : function(o, s, i, u) {
    u === void 0 && (u = i), o[u] = s[i];
  }), t = q && q.__exportStar || function(o, s) {
    for (var i in o)
      i !== "default" && !Object.prototype.hasOwnProperty.call(s, i) && e(s, o, i);
  };
  Object.defineProperty(n, "__esModule", { value: !0 }), t(M, n);
})(N);
var F = { exports: {} };
(function(n, e) {
  var t = typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof q < "u" && q, o = function() {
    function i() {
      this.fetch = !1, this.DOMException = t.DOMException;
    }
    return i.prototype = t, new i();
  }();
  (function(i) {
    (function(u) {
      var c = typeof i < "u" && i || typeof self < "u" && self || typeof c < "u" && c, d = {
        searchParams: "URLSearchParams" in c,
        iterable: "Symbol" in c && "iterator" in Symbol,
        blob: "FileReader" in c && "Blob" in c && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in c,
        arrayBuffer: "ArrayBuffer" in c
      };
      function m(r) {
        return r && DataView.prototype.isPrototypeOf(r);
      }
      if (d.arrayBuffer)
        var g = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], v = ArrayBuffer.isView || function(r) {
          return r && g.indexOf(Object.prototype.toString.call(r)) > -1;
        };
      function A(r) {
        if (typeof r != "string" && (r = String(r)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(r) || r === "")
          throw new TypeError('Invalid character in header field name: "' + r + '"');
        return r.toLowerCase();
      }
      function R(r) {
        return typeof r != "string" && (r = String(r)), r;
      }
      function T(r) {
        var a = {
          next: function() {
            var l = r.shift();
            return { done: l === void 0, value: l };
          }
        };
        return d.iterable && (a[Symbol.iterator] = function() {
          return a;
        }), a;
      }
      function h(r) {
        this.map = {}, r instanceof h ? r.forEach(function(a, l) {
          this.append(l, a);
        }, this) : Array.isArray(r) ? r.forEach(function(a) {
          this.append(a[0], a[1]);
        }, this) : r && Object.getOwnPropertyNames(r).forEach(function(a) {
          this.append(a, r[a]);
        }, this);
      }
      h.prototype.append = function(r, a) {
        r = A(r), a = R(a);
        var l = this.map[r];
        this.map[r] = l ? l + ", " + a : a;
      }, h.prototype.delete = function(r) {
        delete this.map[A(r)];
      }, h.prototype.get = function(r) {
        return r = A(r), this.has(r) ? this.map[r] : null;
      }, h.prototype.has = function(r) {
        return this.map.hasOwnProperty(A(r));
      }, h.prototype.set = function(r, a) {
        this.map[A(r)] = R(a);
      }, h.prototype.forEach = function(r, a) {
        for (var l in this.map)
          this.map.hasOwnProperty(l) && r.call(a, this.map[l], l, this);
      }, h.prototype.keys = function() {
        var r = [];
        return this.forEach(function(a, l) {
          r.push(l);
        }), T(r);
      }, h.prototype.values = function() {
        var r = [];
        return this.forEach(function(a) {
          r.push(a);
        }), T(r);
      }, h.prototype.entries = function() {
        var r = [];
        return this.forEach(function(a, l) {
          r.push([l, a]);
        }), T(r);
      }, d.iterable && (h.prototype[Symbol.iterator] = h.prototype.entries);
      function O(r) {
        if (r.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        r.bodyUsed = !0;
      }
      function X(r) {
        return new Promise(function(a, l) {
          r.onload = function() {
            a(r.result);
          }, r.onerror = function() {
            l(r.error);
          };
        });
      }
      function de(r) {
        var a = new FileReader(), l = X(a);
        return a.readAsArrayBuffer(r), l;
      }
      function le(r) {
        var a = new FileReader(), l = X(a);
        return a.readAsText(r), l;
      }
      function fe(r) {
        for (var a = new Uint8Array(r), l = new Array(a.length), y = 0; y < a.length; y++)
          l[y] = String.fromCharCode(a[y]);
        return l.join("");
      }
      function Y(r) {
        if (r.slice)
          return r.slice(0);
        var a = new Uint8Array(r.byteLength);
        return a.set(new Uint8Array(r)), a.buffer;
      }
      function Z() {
        return this.bodyUsed = !1, this._initBody = function(r) {
          this.bodyUsed = this.bodyUsed, this._bodyInit = r, r ? typeof r == "string" ? this._bodyText = r : d.blob && Blob.prototype.isPrototypeOf(r) ? this._bodyBlob = r : d.formData && FormData.prototype.isPrototypeOf(r) ? this._bodyFormData = r : d.searchParams && URLSearchParams.prototype.isPrototypeOf(r) ? this._bodyText = r.toString() : d.arrayBuffer && d.blob && m(r) ? (this._bodyArrayBuffer = Y(r.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : d.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(r) || v(r)) ? this._bodyArrayBuffer = Y(r) : this._bodyText = r = Object.prototype.toString.call(r) : this._bodyText = "", this.headers.get("content-type") || (typeof r == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : d.searchParams && URLSearchParams.prototype.isPrototypeOf(r) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, d.blob && (this.blob = function() {
          var r = O(this);
          if (r)
            return r;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          if (this._bodyArrayBuffer) {
            var r = O(this);
            return r || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
              this._bodyArrayBuffer.buffer.slice(
                this._bodyArrayBuffer.byteOffset,
                this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
              )
            ) : Promise.resolve(this._bodyArrayBuffer));
          } else
            return this.blob().then(de);
        }), this.text = function() {
          var r = O(this);
          if (r)
            return r;
          if (this._bodyBlob)
            return le(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(fe(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, d.formData && (this.formData = function() {
          return this.text().then(ye);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var pe = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function he(r) {
        var a = r.toUpperCase();
        return pe.indexOf(a) > -1 ? a : r;
      }
      function _(r, a) {
        if (!(this instanceof _))
          throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        a = a || {};
        var l = a.body;
        if (r instanceof _) {
          if (r.bodyUsed)
            throw new TypeError("Already read");
          this.url = r.url, this.credentials = r.credentials, a.headers || (this.headers = new h(r.headers)), this.method = r.method, this.mode = r.mode, this.signal = r.signal, !l && r._bodyInit != null && (l = r._bodyInit, r.bodyUsed = !0);
        } else
          this.url = String(r);
        if (this.credentials = a.credentials || this.credentials || "same-origin", (a.headers || !this.headers) && (this.headers = new h(a.headers)), this.method = he(a.method || this.method || "GET"), this.mode = a.mode || this.mode || null, this.signal = a.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && l)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        if (this._initBody(l), (this.method === "GET" || this.method === "HEAD") && (a.cache === "no-store" || a.cache === "no-cache")) {
          var y = /([?&])_=[^&]*/;
          if (y.test(this.url))
            this.url = this.url.replace(y, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
          else {
            var b = /\?/;
            this.url += (b.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
          }
        }
      }
      _.prototype.clone = function() {
        return new _(this, { body: this._bodyInit });
      };
      function ye(r) {
        var a = new FormData();
        return r.trim().split("&").forEach(function(l) {
          if (l) {
            var y = l.split("="), b = y.shift().replace(/\+/g, " "), f = y.join("=").replace(/\+/g, " ");
            a.append(decodeURIComponent(b), decodeURIComponent(f));
          }
        }), a;
      }
      function me(r) {
        var a = new h(), l = r.replace(/\r?\n[\t ]+/g, " ");
        return l.split("\r").map(function(y) {
          return y.indexOf(`
`) === 0 ? y.substr(1, y.length) : y;
        }).forEach(function(y) {
          var b = y.split(":"), f = b.shift().trim();
          if (f) {
            var x = b.join(":").trim();
            a.append(f, x);
          }
        }), a;
      }
      Z.call(_.prototype);
      function E(r, a) {
        if (!(this instanceof E))
          throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        a || (a = {}), this.type = "default", this.status = a.status === void 0 ? 200 : a.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = a.statusText === void 0 ? "" : "" + a.statusText, this.headers = new h(a.headers), this.url = a.url || "", this._initBody(r);
      }
      Z.call(E.prototype), E.prototype.clone = function() {
        return new E(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new h(this.headers),
          url: this.url
        });
      }, E.error = function() {
        var r = new E(null, { status: 0, statusText: "" });
        return r.type = "error", r;
      };
      var be = [301, 302, 303, 307, 308];
      E.redirect = function(r, a) {
        if (be.indexOf(a) === -1)
          throw new RangeError("Invalid status code");
        return new E(null, { status: a, headers: { location: r } });
      }, u.DOMException = c.DOMException;
      try {
        new u.DOMException();
      } catch {
        u.DOMException = function(a, l) {
          this.message = a, this.name = l;
          var y = Error(a);
          this.stack = y.stack;
        }, u.DOMException.prototype = Object.create(Error.prototype), u.DOMException.prototype.constructor = u.DOMException;
      }
      function J(r, a) {
        return new Promise(function(l, y) {
          var b = new _(r, a);
          if (b.signal && b.signal.aborted)
            return y(new u.DOMException("Aborted", "AbortError"));
          var f = new XMLHttpRequest();
          function x() {
            f.abort();
          }
          f.onload = function() {
            var D = {
              status: f.status,
              statusText: f.statusText,
              headers: me(f.getAllResponseHeaders() || "")
            };
            D.url = "responseURL" in f ? f.responseURL : D.headers.get("X-Request-URL");
            var P = "response" in f ? f.response : f.responseText;
            setTimeout(function() {
              l(new E(P, D));
            }, 0);
          }, f.onerror = function() {
            setTimeout(function() {
              y(new TypeError("Network request failed"));
            }, 0);
          }, f.ontimeout = function() {
            setTimeout(function() {
              y(new TypeError("Network request failed"));
            }, 0);
          }, f.onabort = function() {
            setTimeout(function() {
              y(new u.DOMException("Aborted", "AbortError"));
            }, 0);
          };
          function Ae(D) {
            try {
              return D === "" && c.location.href ? c.location.href : D;
            } catch {
              return D;
            }
          }
          f.open(b.method, Ae(b.url), !0), b.credentials === "include" ? f.withCredentials = !0 : b.credentials === "omit" && (f.withCredentials = !1), "responseType" in f && (d.blob ? f.responseType = "blob" : d.arrayBuffer && b.headers.get("Content-Type") && b.headers.get("Content-Type").indexOf("application/octet-stream") !== -1 && (f.responseType = "arraybuffer")), a && typeof a.headers == "object" && !(a.headers instanceof h) ? Object.getOwnPropertyNames(a.headers).forEach(function(D) {
            f.setRequestHeader(D, R(a.headers[D]));
          }) : b.headers.forEach(function(D, P) {
            f.setRequestHeader(P, D);
          }), b.signal && (b.signal.addEventListener("abort", x), f.onreadystatechange = function() {
            f.readyState === 4 && b.signal.removeEventListener("abort", x);
          }), f.send(typeof b._bodyInit > "u" ? null : b._bodyInit);
        });
      }
      return J.polyfill = !0, c.fetch || (c.fetch = J, c.Headers = h, c.Request = _, c.Response = E), u.Headers = h, u.Request = _, u.Response = E, u.fetch = J, u;
    })({});
  })(o), o.fetch.ponyfill = !0, delete o.fetch.polyfill;
  var s = t.fetch ? t : o;
  e = s.fetch, e.default = s.fetch, e.fetch = s.fetch, e.Headers = s.Headers, e.Request = s.Request, e.Response = s.Response, n.exports = e;
})(F, F.exports);
var ct = F.exports;
const ut = /* @__PURE__ */ ge(ct);
class dt {
  constructor(e, t) {
    this.platformToken = e, this.enclaveToken = t, this.type = "user";
  }
  type;
}
function lt(n) {
  return S.util.binary.base64.decode(
    n.replaceAll("-", "+").replaceAll("_", "/")
  );
}
function ft(n) {
  return S.util.binary.base64.encode(n).replaceAll("+", "-").replaceAll("/", "_");
}
class pt {
  constructor(e) {
    this.enclaveToken = e, this.type = "app";
    const t = lt(e), o = S.util.binary.raw.decode(
      S.md.sha256.create().update(S.util.binary.raw.encode(t)).digest().getBytes()
    );
    this.platformToken = ft(o);
  }
  type;
  platformToken;
}
var L = /* @__PURE__ */ ((n) => (n.GRAPHQL = "graphql", n.SESSION_MESSAGES = "sessions/:sessionId/messages", n.SESSION_MESSAGES_V2 = "sessions/:sessionId/messages_v2", n.USER_UPLOAD_CHUNKS = "uploads/:uploadId/chunks/:chunkHash", n.DATAROOMS_COLLECTION = "datarooms", n.DATAROOM = "datarooms/:dataRoomId", n.ADMIN_DATA_ROOMS_COLLECTION = "admin/datarooms", n.ORGANIZATION_DATA_ROOMS_COLLECTION = "organizations/:organization_id/datarooms", n.USER_DATA_ROOMS_COLLECTION = "users/:user_id/datarooms", n.DATA_ROOMS_COLLECTION = "datarooms", n.DATA_ROOM = "datarooms/:data_room_id", n.DATA_ROOM_ACTIONS = "datarooms/:data_room_id/actions", n.DATA_ROOM_AUDIT_LOG = "datarooms/:data_room_id/auditlog", n.DATA_ROOM_POLICIES = "datarooms/:data_room_id/policies", n.DATA_ROOM_STOP = "datarooms/:data_room_id/stop", n.ACTIONS_COLLECTION = "actions", n.JOBS_COLLECTION = "jobs", n.JOB = "jobs/:job_id", n.JOB_STATUS = "jobs/:job_id/status", n.JOB_FRESHNESS = "jobs/:job_id/freshness", n.JOB_TASKS_COLLECTION = "jobs/:job_id/tasks", n.JOB_RESULT_CHUNKS_STREAM = "jobs/:job_id/result/:task_result_hash/chunks", n.DATASET_CHUNKS_STREAM = "datasets/:manifest_hash/chunks", n.DATASET_PUBLICATIONS = "datasets/publications", n.CHECK_DATA_LABS_COMPATIBILITY = "compatibility/check-data-labs-compatibility", n))(L || {});
class G extends Error {
  constructor(e, t) {
    super(e), this.originalErrors = t, Object.setPrototypeOf(this, G.prototype);
  }
}
class ht {
  prefixUrl;
  headers;
  fetch;
  constructor(e, t, o, s, {
    apiPrefix: i = "",
    additionalAuthHeaders: u = {},
    fetch: c = ut
  } = {}) {
    const d = s ? "https" : "http", m = {
      Authorization: `Bearer ${e.platformToken}`,
      "Authorization-Type": e.type
    };
    this.prefixUrl = `${d}://${t}:${o}${i}`, this.headers = { ...m, ...u }, this.fetch = c.bind(globalThis);
  }
  async makeRequest({
    endpoint: e,
    method: t,
    reqBody: o,
    shouldLogDuration: s = !1,
    headers: i = {},
    options: u = {}
  }) {
    const c = `${this.prefixUrl}/${e}`, d = ue({
      backoffFactor: ee.requestRetryBackoffFactor,
      total: u.retry ? ee.requestRetryTotal : 1
    }), m = [];
    let g;
    s && (g = Date.now());
    for await (const v of d)
      try {
        const A = await this.fetch.call(globalThis, c, {
          body: o,
          headers: { ...this.headers, ...i },
          method: t
        });
        if (A.status === 408 || A.status === 429 || A.status >= 500) {
          const R = await A.text();
          m.push(R), console.warn(
            `Failed to ${t} to ${c}, re-attempt ${v} [code ${A.status}]: ${R}`
          );
          continue;
        } else {
          if (s && g !== void 0) {
            const R = Date.now() - g;
            console.info(`${t} ${c} ${v} ${R}ms`);
          }
          return A;
        }
      } catch (A) {
        m.push(`${A}`), console.warn(
          `Failed to ${t} to ${c}, re-attempt ${v}: ${A}`
        );
        continue;
      }
    throw new G(
      `Failed to ${t} to ${c}, maximum re-attempts reached. Latest error: ${m.slice(-1)[0]}`,
      m
    );
  }
  async post(e) {
    return this.makeRequest({ ...e, method: "POST" });
  }
  async put(e) {
    return this.makeRequest({ ...e, method: "PUT" });
  }
  async patch(e) {
    return this.makeRequest({ ...e, method: "PATCH" });
  }
  async get(e) {
    return this.makeRequest({ ...e, method: "GET" });
  }
  async head(e) {
    return this.makeRequest({ ...e, method: "HEAD" });
  }
  async delete(e) {
    return this.makeRequest({ ...e, method: "DELETE" });
  }
}
const xt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Api: ht,
  AppToken: pt,
  ClientApiError: G,
  Endpoints: L,
  UserToken: dt
}, Symbol.toStringTag, { value: "Module" }));
function yt(n, e, t) {
  return $.DataNoncePubkey.create({
    data: n,
    nonce: e,
    pubkey: t
  });
}
function mt(n) {
  const e = $.DataNoncePubkey.decodeDelimited(n);
  return {
    data: e.data,
    nonce: e.nonce,
    pubkey: e.pubkey
  };
}
class I extends Error {
  constructor(e) {
    super(e), Object.setPrototypeOf(this, I.prototype);
  }
}
class re {
  sessionId;
  api;
  enclavePublicKey;
  logRequests;
  channelKeyPair;
  constructor(e, t, o, s) {
    this.api = e, this.enclavePublicKey = t, this.logRequests = s, this.sessionId = o, this.channelKeyPair = C.box.keyPair();
  }
  static async create({
    api: e,
    graphql: t,
    logRequests: o,
    driverAttestationSpecification: s,
    attestationSpecificationHash: i,
    unsafeDisableKnownRootCaCheck: u
  }) {
    const c = await t.post({
      query: et(`
        mutation CreateSession($input: CreateSessionInput!) {
          session {
            create(input: $input) {
              record {
                id
                fatquoteNewTcbLevel
              }
            }
          }
        }
      `),
      variables: {
        input: {
          enclaveAttestationHash: i
        }
      }
    }), d = c.session.create.record.id, m = S.util.binary.base64.decode(
      c.session.create.record.fatquoteNewTcbLevel
    ), g = V.Fatquote.decodeDelimited(m), v = new Re(s);
    u && v.disableKnownRootCaCheck();
    const R = (await v.verify(g)).slice(0, 32);
    return new re(e, R, d, o);
  }
  encryptAndEncode(e) {
    const t = C.randomBytes(C.box.nonceLength), o = C.box(
      e,
      t,
      this.enclavePublicKey,
      this.channelKeyPair.secretKey
    );
    return yt(
      o,
      t,
      this.channelKeyPair.publicKey
    );
  }
  decodeAndDecrypt(e) {
    const t = mt(e);
    return C.box.open(
      t.data,
      t.nonce,
      this.enclavePublicKey,
      this.channelKeyPair.secretKey
    );
  }
  getUserAuth(e) {
    const t = C.scalarMult(
      this.channelKeyPair.secretKey,
      this.enclavePublicKey
    ), o = oe(
      64,
      t,
      new Uint8Array(0),
      S.util.binary.raw.decode("IdP KDF Context")
    ), s = B(
      o,
      new TextEncoder().encode(e.getUserId())
    ), i = new Uint8Array([
      ...this.channelKeyPair.publicKey,
      ...this.enclavePublicKey
    ]), u = e.sign(i), c = new De(u, s, e), d = w.Pki.create({
      certChainPem: c.getCertChain(),
      idMac: c.getMacTag(),
      signature: c.getSignature()
    });
    return w.UserAuth.create({
      enclaveEndorsements: e.endorsements,
      pki: d
    });
  }
  async sendRequest(e, t, o) {
    if (this.logRequests) {
      const u = e.toJSON();
      for (const c of Object.getOwnPropertyNames(u))
        if (c.endsWith("Request")) {
          let d = `[enclave request] ${c}`;
          const m = u[c].dataRoomId;
          m && (d += ` | DCR: ${ce(m)}`), console.info(d);
        }
    }
    e.userAuth = this.getUserAuth(o);
    const s = w.GcgRequest.encodeDelimited(e).finish();
    return (await this.sendRequestRaw(
      s,
      t
    )).map((u) => {
      const c = w.GcgResponse.decodeDelimited(u);
      if (c.failure)
        throw console.error(e, c), new I(`${c.failure}`);
      return c;
    });
  }
  async sendRequestRaw(e, t) {
    const o = await self.crypto.subtle.digest("SHA-256", e), s = S.util.binary.hex.encode(o);
    return await N.coalesceAsync(s, async () => {
      const u = W.ComputeNodeProtocol.encodeDelimited({
        version: t
      }).finish(), c = $.Request.encodeDelimited({
        deltaRequest: this.encryptAndEncode(
          new Uint8Array([...u, ...e])
        )
      }).finish(), d = L.SESSION_MESSAGES.replace(
        ":sessionId",
        this.sessionId
      ), m = await (await this.api.post({
        endpoint: d,
        headers: {
          "Content-type": "application/octet-stream"
        },
        options: {
          retry: !1
        },
        reqBody: c
      })).arrayBuffer(), g = Q.Reader.create(new Uint8Array(m)), v = [];
      for (; g.pos < g.len; ) {
        const A = $.Response.decodeDelimited(g);
        if (A.response === "unsuccessfulResponse")
          throw new Error(`${A.unsuccessfulResponse}`);
        const R = A.successfulResponse, T = this.decodeAndDecrypt(R);
        if (T == null)
          throw new Error("Response decryption failed");
        const h = Q.Reader.create(T), O = W.ComputeNodeProtocol.decodeDelimited(h);
        if (O.version !== t)
          throw new Error(
            `Unsupported protocol version in response. Expected ${t}, received ${O.version} from enclave`
          );
        v.push(h.buf.subarray(h.pos));
      }
      return v;
    });
  }
  async sendCompilableRequest(e, t, o, s) {
    const i = e(t, this), u = await this.sendRequestRaw(
      i,
      s
    );
    return o(u);
  }
  async sendRequestV2(e) {
    const t = $.DataNoncePubkey.encodeDelimited(
      this.encryptAndEncode(w.GcgRequestV2.encodeDelimited(e).finish())
    ).finish(), o = await self.crypto.subtle.digest(
      "SHA-256",
      t
    ), s = S.util.binary.hex.encode(o);
    return await N.coalesceAsync(s, async () => {
      const u = L.SESSION_MESSAGES_V2.replace(
        ":sessionId",
        this.sessionId
      ), c = new Uint8Array(
        await (await this.api.post({
          endpoint: u,
          headers: {
            "Content-type": "application/octet-stream"
          },
          options: {
            retry: !1
          },
          reqBody: t
        })).arrayBuffer()
      ), d = $.Response.decodeDelimited(c);
      if (d.response === "unsuccessfulResponse")
        throw new Error(`${d.unsuccessfulResponse}`);
      const m = this.decodeAndDecrypt(
        d.successfulResponse
      );
      if (m == null)
        throw new Error("Response decryption failed");
      return w.GcgResponseV2.decodeDelimited(m);
    });
  }
  stringRepresentation() {
    return `Channel(sessionId: ${this.sessionId})`;
  }
}
class H {
  data;
  state;
  constructor(e, t) {
    this.data = e, this.state = t;
  }
}
class se {
  client;
  channel;
  authToken;
  constructor(e, t) {
    this.client = e, this.channel = t, this.authToken = null;
  }
  async setAuthToken(e) {
    this.authToken = e;
  }
  static async create({
    client: e,
    connection: t
  }) {
    return new se(e, t);
  }
  async sendUnauthenticatedRequest(e) {
    const t = w.GcgRequestV2.create({
      unauthenticated: e
    }), o = await this.channel.sendRequestV2(t);
    if (o.failure)
      throw new I(o.failure);
    const s = o.success;
    if (s?.unauthenticated === null || s?.unauthenticated === void 0)
      throw new Error(
        `Expected \`authenticated\` response, got ${s}`
      );
    return s.unauthenticated;
  }
  async sendAuthenticatedRequest(e) {
    if (this.authToken == null)
      throw new Error(
        "sendAuthenticatedRequest called without an enclave token. Please use session.setAuthToken()"
      );
    this.authToken.type === "enclave-access" ? e.accessToken = this.authToken.value : e.apiToken = this.authToken.value;
    const t = w.GcgRequestV2.create({
      authenticated: e
    }), o = await this.channel.sendRequestV2(t);
    if (o.failure)
      throw new I(o.failure);
    const s = o.success;
    if (s?.authenticated === null || s?.authenticated === void 0)
      throw new Error(
        `Expected \`authenticated\` response, got ${s}`
      );
    return s.authenticated;
  }
  async sendAuthenticationRequest(e) {
    const t = w.UnauthenticatedRequest.create({
      authentication: e
    }), o = await this.sendUnauthenticatedRequest(
      t
    );
    if (o.authentication === null || o.authentication === void 0)
      throw new Error(
        `Expected \`authentication\` response, got ${o}`
      );
    return o.authentication;
  }
  async sendSecretStoreRequest(e) {
    const t = w.AuthenticatedRequest.create({
      secretStore: e
    }), o = await this.sendAuthenticatedRequest(t);
    if (o.secretStore === null || o.secretStore === void 0)
      throw new Error(
        `Expected \`secretStore\` response, got ${o}`
      );
    return o.secretStore;
  }
  async removeSecret(e, t) {
    const o = U.SecretStoreRequest.create({
      removeSecret: {
        expectedCasIndex: t,
        id: e
      }
    }), s = await this.sendSecretStoreRequest(o);
    if (s.removeSecret === null || s.removeSecret === void 0)
      throw new Error(`Expected \`removeSecret\` response, got ${s}`);
    if (s.removeSecret.removed === null || s.removeSecret.removed === void 0)
      throw new Error(`Expected \`removed\` in response, got ${s}`);
    return s.removeSecret.removed;
  }
  async getSecret(e) {
    const t = U.SecretStoreRequest.create({
      getSecret: {
        id: e,
        version: K.SECRET_STORE_ENTRY_STATE_VERSION
      }
    }), o = await this.sendSecretStoreRequest(t);
    if (o.getSecret === null || o.getSecret === void 0)
      throw new Error(`Expected \`getSecret\` response, got ${o}`);
    const s = o.getSecret;
    if (s?.secret?.content === void 0 || s?.secret?.content === null || s?.secret?.state === void 0 || s?.secret?.state === null || s?.casIndex === void 0 || s?.casIndex === null)
      throw new Error(
        `Expected \`secret.content\`, \`secret.state\` and \`casIndex\` in response, got ${s}`
      );
    return [
      new H(
        s.secret.content,
        K.SecretStoreEntryStateSchema.parse(
          JSON.parse(new TextDecoder().decode(s.secret.state))
        )
      ),
      Number(s.casIndex)
    ];
  }
  async createSecret(e) {
    const t = U.SecretStoreRequest.create({
      createSecret: {
        secret: {
          content: e.data,
          state: new TextEncoder().encode(JSON.stringify(e.state))
        }
      }
    }), o = await this.sendSecretStoreRequest(t);
    if (o.createSecret === null || o.createSecret === void 0)
      throw new Error(`Expected \`createSecret\` response, got ${o}`);
    const s = o.createSecret;
    if (s?.id === void 0 || s?.id === null)
      throw new Error(
        `Expected \`id\` in response, got ${s}`
      );
    return s.id;
  }
  async updateSecretAcl(e, t, o) {
    const s = U.SecretStoreRequest.create({
      updateSecretAcl: {
        expectedCasIndex: o,
        id: e,
        newAcl: new TextEncoder().encode(JSON.stringify(t)),
        version: K.SECRET_STORE_ENTRY_STATE_VERSION
      }
    }), i = await this.sendSecretStoreRequest(s);
    if (i.updateSecretAcl === null || i.updateSecretAcl === void 0)
      throw new Error(`Expected \`updateSecretAcl\` response, got ${i}`);
    if (i.updateSecretAcl.updated === null || i.updateSecretAcl.updated === void 0)
      throw new Error(`Expected \`updated\` in response, got ${i}`);
    return i.updateSecretAcl.updated;
  }
  async createApiToken(e) {
    const t = w.AuthenticatedRequest.create({
      createApiToken: { name: e }
    }), o = await this.sendAuthenticatedRequest(t);
    if (o.createApiToken === null || o.createApiToken === void 0)
      throw new Error(`Expected \`createApiToken\` response, got ${o}`);
    const s = o.createApiToken;
    if (s?.token === void 0 || s?.token === null)
      throw new Error(
        `Expected \`token\` in response, got ${s}`
      );
    return s.token;
  }
  async getApiTokens() {
    const e = w.AuthenticatedRequest.create({
      getApiTokens: {}
    }), t = await this.sendAuthenticatedRequest(e);
    if (t.getApiTokens === null || t.getApiTokens === void 0)
      throw new Error(`Expected \`getApiTokens\` response, got ${t}`);
    if (t.getApiTokens.tokens === null || t.getApiTokens.tokens === void 0)
      throw new Error(
        `Expected \`tokens\` in response, got ${t.getApiTokens}`
      );
    return t.getApiTokens.tokens;
  }
  async deleteApiToken(e) {
    const t = w.AuthenticatedRequest.create({
      deleteApiToken: { token: e }
    }), o = await this.sendAuthenticatedRequest(t);
    if (o.deleteApiToken === null || o.deleteApiToken === void 0)
      throw new Error(`Expected \`deleteApiToken\` response, got ${o}`);
  }
  async getVerificationKey() {
    const e = w.AuthenticatedRequest.create({
      getVerificationKey: {}
    }), t = await this.sendAuthenticatedRequest(e);
    if (t.getVerificationKey === null || t.getVerificationKey === void 0)
      throw new Error(
        `Expected \`getVerificationKey\` response, got ${t}`
      );
    const o = t.getVerificationKey;
    if (o?.verificationKey === void 0 || o?.verificationKey === null)
      throw new Error(
        `Expected \`verificationKey\` in response, got ${o}`
      );
    return o.verificationKey;
  }
  async createPolicy(e) {
    const t = await this.client.ensureDatasetScope(), o = new Uint8Array(Se.Buffer.from(t, "hex")), s = w.AuthenticatedRequest.create({
      createPolicy: {
        policy: e,
        scope: o
      }
    }), i = await this.sendAuthenticatedRequest(s);
    if (!i.createPolicy)
      throw new Error(`Expected \`createPolicy\` response, got ${i}`);
    if (!i.createPolicy.policyId)
      throw new Error(
        `Expected \`policyId\` in response, got ${i.createPolicy}`
      );
    return i.createPolicy.policyId;
  }
  async sendDataRoomStateActionRequest(e, t) {
    const o = w.AuthenticatedRequest.create({
      dcrAction: {
        action: new TextEncoder().encode(JSON.stringify(t)),
        dataRoomId: e
      }
    }), s = await this.sendAuthenticatedRequest(o);
    if (!s.dcrAction)
      throw new Error(`Expected \`dcrAction\` response, got ${s}`);
    if (!s.dcrAction.response)
      throw new Error(
        `Expected \`response\` in dcrAction, got ${s.dcrAction}`
      );
    return JSON.parse(
      new TextDecoder().decode(s.dcrAction.response)
    );
  }
  async sendRetrieveResultEncryptionKeyRequest(e, t) {
    const o = w.AuthenticatedRequest.create({
      retrieveResultEncryptionKey: {
        jobId: e,
        taskResultHashHex: t
      }
    }), s = await this.sendAuthenticatedRequest(o);
    if (!s.retrieveResultEncryptionKey)
      throw new Error(
        `Expected \`retrieveResultEncryptionKey\` response, got ${s}`
      );
    const i = s.retrieveResultEncryptionKey;
    if (!i.manifestHashHex || !i.encryptionKey)
      throw new Error(
        `Expected \`manifestHashHex\` and \`encryptionKey\` in response, got ${JSON.stringify(s)}`
      );
    return [i.manifestHashHex, i.encryptionKey];
  }
  async sendExportResultAsDatasetRequest(e, t, o, s = null) {
    const i = s === null ? {
      datasetName: o,
      jobId: e,
      raw: {},
      taskResultHashHex: t
    } : {
      datasetName: o,
      jobId: e,
      taskResultHashHex: t,
      zip: {
        path: s
      }
    }, u = w.AuthenticatedRequest.create({
      exportResultAsDataset: i
    }), c = await this.sendAuthenticatedRequest(u);
    if (!c.exportResultAsDataset || !c.exportResultAsDataset.manifestHashHex || !c.exportResultAsDataset.secretId || !c.exportResultAsDataset.datasetId)
      throw new Error(
        `Malformed response, got ${c.exportResultAsDataset}`
      );
    return [
      c.exportResultAsDataset.manifestHashHex,
      c.exportResultAsDataset.secretId,
      c.exportResultAsDataset.datasetId
    ];
  }
}
function B(n, e) {
  const t = S.hmac.create();
  return t.start("sha512", S.util.binary.raw.encode(n)), t.update(S.util.binary.raw.encode(e)), S.util.binary.raw.decode(t.digest().bytes());
}
function oe(n, e, t, o) {
  t.length === 0 && (t = new Uint8Array(64));
  const s = B(t, e);
  let i = new Uint8Array(), u = new Uint8Array();
  for (let c = 0; c < Math.ceil(n / 64); c++) {
    const d = new Uint8Array([c + 1]);
    i = B(s, new Uint8Array([...i, ...o, ...d])), u = new Uint8Array([...u, ...i]);
  }
  return u.slice(0, n);
}
function j(n) {
  const e = S.md.sha256.create();
  return e.update(
    S.util.binary.raw.encode(
      V.AttestationSpecification.encodeDelimited(n).finish()
    )
  ), e.digest().toHex();
}
function bt(n, e, t) {
  const o = V.AttestationSpecification.create(e), s = j(o);
  for (const i of t)
    if (j(i.proto) === s) {
      const u = i.decoder;
      if (u !== void 0)
        return u.decode(n);
    }
}
function ae(n, e) {
  const t = /* @__PURE__ */ new Map();
  if (n.elements) {
    const o = /* @__PURE__ */ new Map();
    for (const s of Object.values(n.elements))
      s.id && o.set(s.id, s);
    for (const s of Object.values(n.elements)) {
      const i = s.id, u = s.computeNode?.branch;
      if (i && u) {
        const c = u.config, d = u.attestationSpecificationId;
        if (d && c) {
          const m = o.get(d)?.attestationSpecification;
          if (m && m) {
            const g = bt(
              c,
              m,
              e
            );
            g && t.set(i, g);
          }
        }
      }
    }
  }
  return t;
}
async function At(n, e) {
  const t = ae(
    n,
    e
  ), o = {};
  for (const s of Object.values(n.elements)) {
    const i = s.id;
    if (i && s.computeNode?.branch && t.has(i)) {
      const u = s.computeNode.branch.toJSON();
      o[i] = {
        ...u,
        config: t.get(i)
      };
      continue;
    }
    i && (o[i] = s.toJSON());
  }
  return o;
}
function wt(n) {
  const e = Math.floor(1.5 * n), t = z.withSize(e);
  let o = 0;
  return new TransformStream({
    flush(s) {
      if (t.size() > 0) {
        const i = t.view(!0);
        s.enqueue({ data: i, progress: o }), t.reset();
      }
    },
    transform({ data: s, progress: i }, u) {
      for (o = i, t.extend(s); t.size() >= n; ) {
        const c = t.view().slice(0, n);
        u.enqueue({ data: c, progress: o });
        const d = new Uint8Array([
          ...t.view().slice(n)
        ]);
        t.reset(), t.extend(d);
      }
    }
  });
}
function St(n) {
  let e = [];
  return new TransformStream({
    flush(t) {
      e.length > 0 && t.enqueue(e);
    },
    transform(t, o) {
      e.length < n ? e.push(t) : (o.enqueue(e), e = [t]);
    }
  });
}
async function ie(n) {
  return new Promise((e) => setTimeout(e, n));
}
function ce(n) {
  return S.util.binary.hex.encode(n);
}
function gt(n) {
  return S.util.binary.hex.decode(n);
}
async function* ue({
  total: n = 1,
  backoffFactor: e
}) {
  if (n < 1)
    throw new Error("total must be greater than 0");
  let t = 0;
  for (; t < n; ) {
    yield t;
    const o = Math.pow(2, t) * e;
    await ie(o * 1e3), t += 1;
  }
}
function Rt(n, e) {
  const t = we.intersection(n, e);
  if (t.length === 0) {
    const s = Math.min(...n), i = Math.max(...e);
    let u = `Endpoint is only available with protocol versions [${e}] but the enclave only supports [${n}].
`;
    throw s > i ? u += "Try upgrading to a newer version of the SDK" : u += "Try using an older version of the SDK", new Error(u);
  }
  return Math.max(...t);
}
function Dt(n, e) {
  let t;
  if (n.kind === "dataset_key")
    t = new H(n.value, {
      acl: {
        type: "UsersList",
        users: [
          {
            id: e,
            role: "Owner"
          }
        ]
      },
      manifest_hash: n.key,
      type: "DatasetKey",
      version: "V0"
    });
  else if (n.kind === "dataset_metadata")
    t = new H(n.value, {
      acl: {
        type: "UsersList",
        users: [
          {
            id: e,
            role: "Owner"
          }
        ]
      },
      manifest_hash: n.key,
      type: "DatasetMetadata",
      version: "V0"
    });
  else if (n.kind === "pending_dataset_import")
    t = new H(n.value, {
      acl: {
        type: "UsersList",
        users: [
          {
            id: e,
            role: "Owner"
          }
        ]
      },
      data_connector_job_id: n.key,
      type: "PendingDatasetImport",
      version: "V0"
    });
  else
    throw n.kind === "other_secret" ? new Error("Other secret cannot be migrated automatically") : new Error("Unknown secret kind");
  return t;
}
const Pt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  computeHexHashForAttestationSpec: j,
  createGroups: St,
  decodeComputeNodeConfigurations: ae,
  decodeDataRoomConfiguration: At,
  fromHex: gt,
  getProtocol: Rt,
  getRetryIterator: ue,
  hkdf: oe,
  hmac_sha512: B,
  keychainEntryToSecret: Dt,
  sleep: ie,
  toHex: ce,
  transformChunkSize: wt
}, Symbol.toStringTag, { value: "Module" }));
export {
  ht as A,
  G as C,
  ve as D,
  L as E,
  se as S,
  dt as U,
  Rt as a,
  ce as b,
  St as c,
  I as d,
  ue as e,
  gt as f,
  et as g,
  j as h,
  re as i,
  _e as j,
  Ee as k,
  xt as l,
  pt as m,
  H as n,
  ae as o,
  At as p,
  oe as q,
  z as r,
  B as s,
  wt as t,
  Pt as u,
  Dt as v,
  ie as w
};
//# sourceMappingURL=utils-dinPOBnH.js.map
